module.exports = __webpack_public_path__ + "static/media/center_coordinates.398111b9.png";